import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { customStyles } from '../../../../../HelperFunctions';
import { useFormik } from 'formik';
import axios from 'axios';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../../Config';
import Select from 'react-select';

const AddFFAirExpConsoleManifest = ({
    handleClose,
    show,
    token,
    user_id,
    loadingFFAirExpUnusedConsoleManifestMAWBAddList,
    addMAWBListOptions,
    refresh

}) => {

    const [disableSubmit, setDisableSubmit] = useState(false);

    const initialValues = {
        mawb_id: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            handleClose();
                            refresh();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });
    return (
        <>
            {
                <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Add Console Manifest</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-md-12 mt-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Select MAWB
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <Select
                                                placeholder="Select MAWB No."
                                                className='custom-selector'
                                                options={addMAWBListOptions}
                                                styles={customStyles}
                                                name="mawb_id"
                                                onChange={option => {
                                                    formik.setFieldValue('mawb_id', option.value);
                                                }}
                                                value={addMAWBListOptions.find(option => option.value === formik.values.mawb_id || null)}
                                                isLoading={loadingFFAirExpUnusedConsoleManifestMAWBAddList}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row d-flex justify-content-end mt-2">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Offcanvas.Body>
                </Offcanvas>
            }


        </>

    )
}

export default AddFFAirExpConsoleManifest